import type UseNativeDriver from './types';

const useNativeDriver: UseNativeDriver = false;

export default useNativeDriver;
